<template>
  <div class="level">
    <div class="level-left">
      <div class="level-item">
        <b-input
          v-if="editing"
          v-model="newTitle"
          @keyup.enter.native="stopEditing"
          @keyup.esc.native="cancelEditing"
          @blur="stopEditing"
          ref="titleEdit"
        />
        <h1
          v-else-if="title"
          class="title"
          :class="{ editable: this.$route.meta.editableTitle }"
          @click="startEditing"
          ref="pageTitle"
        >
          {{ title }}
          <span class="icon is-small">
            <i class="fas fa-pencil-alt"></i>
          </span>
        </h1>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item">
        <breadcrumb></breadcrumb>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from './Breadcrumb'
import { createNamespacedHelpers, mapActions } from 'vuex'
const { mapState: mapUserState } = createNamespacedHelpers('general')

export default {
  name: 'HeaderPage',
  components: { Breadcrumb },
  computed: {
    ...mapUserState({
      role: state => state.user.role,
      title: state => state.title
    }),
    isAdmin() {
      return this.role === 'ADMIN'
    }
  },
  data() {
    return {
      editing: false,
      newTitle: ''
    }
  },
  created() {
    let title = ''
    if (this.$route.meta && this.$route.meta.title) {
      if (typeof this.$route.meta.title === 'function') {
        const header = this.$route.meta.title.apply(this)
        title = header.title[this.$i18n.locale] ? header.title[this.$i18n.locale].title : ''
        const name = header.name
        title = `${title ? title + '#' : ''} ${name}`
      } else {
        title = this.$route.meta.title[this.$i18n.locale].title
      }
    }
    this.setTitle(title)
  },
  methods: {
    ...mapActions('general', ['setTitle']),
    startEditing() {
      if (!this.$route.meta.editableTitle) {
        return
      }
      this.editing = true
      this.newTitle = this.title
      this.$nextTick(() => {
        this.$refs.titleEdit.focus()
      })
    },
    stopEditing() {
      this.editing = false
      this.setTitle(this.newTitle)
    },
    cancelEditing() {
      this.editing = false
    }
  }
}
</script>

<style lang="scss">
.level {
  .level-left {
    .title {
      &.editable {
        cursor: pointer;
        &:hover {
          .icon {
            display: inline;
          }
        }
      }
      .icon {
        display: none;
        font-size: 1rem;
      }
    }
  }
}
</style>
